// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm-dialog-div {\n  background-color: var(--v-white-base);\n  position: relative;\n  border-radius: var(--brand-surface-radius, 4px) !important;\n  width: 500px;\n}\n.confirm-dialog-div button.v-btn.close-dialog {\n  right: 4px !important;\n  top: 6px !important;\n}", ""]);
// Exports
module.exports = exports;
